import { EmployeeType } from 'modules/contracts/hooks/useFetchFrenchContractData'
import { ContractFieldsProps } from 'modules/contracts/lib/types'

export const getProfessionalCategory = (
  categories: ContractFieldsProps[],
  categoryId?: number
): ContractFieldsProps | undefined => {
  return categories.find(({ id }) => id === categoryId)
}

export const getEmployeeType = (
  types: EmployeeType[],
  employeeId?: string
): EmployeeType | undefined => {
  return types.find((type) => type.value === employeeId)
}

export const getNiveau = (
  levels: ContractFieldsProps[],
  levelId?: number
): ContractFieldsProps | undefined => {
  return levels.find(({ id }) => id === levelId)
}

export const getStep = (
  steps: ContractFieldsProps[],
  stepId?: number
): ContractFieldsProps | undefined => {
  return steps.find(({ id }) => id === stepId)
}

export const getMutual = (
  mutuals: ContractFieldsProps[],
  mutualId?: number
): ContractFieldsProps | undefined => {
  return mutuals.find((mutual) => mutual.id === mutualId)
}
